'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_DELIVERY_CONFIG = exports.SET_DELIVERY_CONFIG = 'SET_DELIVERY_CONFIG';
var SET_FREE_GIFT_CODE_CONFIG = exports.SET_FREE_GIFT_CODE_CONFIG = 'SET_FREE_GIFT_CODE_CONFIG';
var SET_CLAIMED_FREE_CODE_GIFT = exports.SET_CLAIMED_FREE_CODE_GIFT = 'SET_CLAIMED_FREE_CODE_GIFT';
var SET_FREE_GIFT_TIERS_CONFIG = exports.SET_FREE_GIFT_TIERS_CONFIG = 'SET_FREE_GIFT_TIERS_CONFIG';
var SET_ITEM_BEING_ADDED_ID = exports.SET_ITEM_BEING_ADDED_ID = 'SET_ITEM_BEING_ADDED_ID';
var SET_LOADING = exports.SET_LOADING = 'SET_LOADING';
var ADD_ERROR = exports.ADD_ERROR = 'ADD_ERROR';
var TOGGLE_ERROR = exports.TOGGLE_ERROR = 'TOGGLE_ERROR';
var REMOVE_ERROR = exports.REMOVE_ERROR = 'REMOVE_ERROR';
var REMOVE_ALL_ERRORS = exports.REMOVE_ALL_ERRORS = 'REMOVE_ALL_ERRORS';
var UPDATE_LINE_ITEMS = exports.UPDATE_LINE_ITEMS = 'UPDATE_LINE_ITEMS';